var map = {
	"./drawing1.jpg": 3282,
	"./drawing2.jpg": 7442,
	"./drawing3.gif": 2294,
	"./drawing4.jpg": 8471,
	"./drawing5.jpg": 2535,
	"./fantasmino.png": 1596,
	"./fox.jpg": 9702,
	"./gufo.jpg": 147,
	"./impossible-circle.jpg": 4068,
	"./littleguylovesm-100.jpg": 9051,
	"./sushi.jpg": 1938,
	"./the.jpg": 951,
	"./whale.jpg": 4112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2672;